import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const scenarios = [
  [
    { name: "Balloons", price: 3.80 },
    { name: "Cake", price: 5.99 },
    { name: "Gifts", price: 7.15 },
    { name: "Decorations", price: 4.45 },
    { name: "Party Hats", price: 2.60 }
  ],
  [
    { name: "Invitations", price: 3.50 },
    { name: "Cupcakes", price: 6.99 },
    { name: "Piñata", price: 8.25 },
    { name: "Goodie Bags", price: 3.20 }
  ],
  [
    { name: "Tableware", price: 4.75 },
    { name: "Juice Boxes", price: 5.40 },
    { name: "Confetti", price: 2.99 },
    { name: "Birthday Banner", price: 6.10 }
  ]
];

const BirthdayBashBudget = () => {
  const [currentScenario, setCurrentScenario] = useState(0);
  const [roundedInputs, setRoundedInputs] = useState([]);
  const [userTotal, setUserTotal] = useState('');
  const [feedback, setFeedback] = useState('');
  const [showNext, setShowNext] = useState(false);
  const [budget, setBudget] = useState(25); // <-- randomize this

  const items = scenarios[currentScenario];

  const getRandomBudget = () => Math.floor(Math.random() * 16 + 20); // $20–$35

  useEffect(() => {
    setRoundedInputs(Array(items.length).fill(''));
    setUserTotal('');
    setFeedback('');
    setShowNext(false);
    setBudget(getRandomBudget()); // update budget on scenario load
  }, [currentScenario]);

  const roundPrice = (value) => Math.round(value);

  const handleInputChange = (index, value) => {
    const updated = [...roundedInputs];
    updated[index] = value;
    setRoundedInputs(updated);
  };

  const handleCheck = () => {
    let total = 0;
    let correct = true;
    let message = '';

    items.forEach((item, i) => {
      const expected = roundPrice(item.price);
      const user = parseInt(roundedInputs[i]);
      if (user === expected) {
        message += `✅ ${item.name}: Correct!<br>`;
      } else {
        message += `❌ ${item.name}: Should be $${expected}<br>`;
        correct = false;
      }
      total += expected;
    });

    const parsedTotal = parseInt(userTotal);
    message += `<br>Total Estimated: $${total}`;

    if (parsedTotal === total) {
      message += `<br>✅ Your total estimate is correct!`;
    } else {
      message += `<br>❌ Your total estimate is off. Try again!`;
      correct = false;
    }

    if(correct&&(parsedTotal=== total)){
                  const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }

    message += total <= budget
      ? `<br>🎉 You're under budget!`
      : `<br>💸 You're over budget!`;

    setFeedback(message);
    setShowNext(correct && total <= budget);

  };

  const nextScenario = () => {
    setCurrentScenario((currentScenario + 1) % scenarios.length);
  };

  const styles = {
    container: {
      fontFamily: "'Comic Sans MS', cursive",
      background: 'linear-gradient(to bottom,rgb(236, 223, 235),rgb(210, 164, 230))',
      padding: '2rem 1rem',
      textAlign: 'center',
      minHeight: '100vh',
      boxSizing: 'border-box'
    },
    itemList: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: '16px',
      justifyContent: 'center',
      marginTop: '20px'
    },
    item: {
      background: '#ffe0b2',
      border: '2px solid #ffb74d',
      padding: '15px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      fontSize: 'clamp(1rem, 2vw, 1.1rem)'
    },
    input: {
      width: '',
      marginTop: '10px',
      padding: '5px',
      textAlign: 'center',
      fontSize: '1rem'
    },
    totalInput: {
      fontSize: '1rem',
      padding: '8px 12px',
      borderRadius: 6,
      border: '2px solid #f9a825',
      textAlign: 'center',
      width: 'fit-content',
      margin: '10px auto',
      display: 'block'
    },
    button: {
      padding: '12px 24px',
      fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
      borderRadius: '8px',
      border: 'none',
      backgroundColor: '#ff7043',
      color: 'white',
      marginTop: '20px',
      cursor: 'pointer'
    },
    result: {
      fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
      marginTop: '20px',
      fontWeight: 'bold',
      whiteSpace: 'pre-line',
      maxWidth: '600px',
      marginInline: 'auto'
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={{ fontSize: "clamp(1.5rem, 5vw, 2.5rem)", color: "#d84315" }}>🎂 Birthday Bash Budget</h2>
      <p style={{ fontSize: "clamp(1rem, 3vw, 1.2rem)" }}>
        You have a <strong>${budget}</strong> budget to plan a party! Round the item
        prices, estimate your total, and see if you're under budget!
      </p>

      <div style={styles.itemList}>
        {items.map((item, i) => (
          <div key={i} style={styles.item}>
            <strong>{item.name}</strong><br />
            ${item.price.toFixed(2)}<br />
            Round to nearest $: <br />
            <input
              type="number"
              value={roundedInputs[i]}
              onChange={(e) => handleInputChange(i, e.target.value)}
              style={styles.input}
            />
          </div>
        ))}
      </div>

      <div style={{ marginTop: "30px" }}>
        <label style={{ fontSize: "1.1rem" }}>Estimated Total: $</label>
        <input
          type="number"
          value={userTotal}
          onChange={(e) => setUserTotal(e.target.value)}
          style={styles.totalInput}
        />
        <button onClick={handleCheck} style={styles.button}>Check Answer</button>
      </div>

      <div
        id="result"
        style={styles.result}
        dangerouslySetInnerHTML={{ __html: feedback }}
      ></div>

      {showNext && (
        <div style={{ marginTop: "30px" }}>
          <button onClick={nextScenario} style={styles.button}>
            Next Scenario ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default BirthdayBashBudget;
